var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      staticClass: "process",
      attrs: { placement: "bottom-start", trigger: "hover", width: "320" }
    },
    [
      _c(
        "div",
        { staticStyle: { "max-height": "200px", "overflow-y": "scroll" } },
        [
          _vm.steps.length
            ? _c(
                "el-steps",
                {
                  style: { height: _vm.steps.length * 40 + "px" },
                  attrs: { direction: "vertical", space: 40 }
                },
                _vm._l(_vm.steps, function(step, index) {
                  return _c("el-step", {
                    key: index,
                    staticStyle: { height: "60px" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "icon",
                          fn: function() {
                            return [
                              _c("el-progress", {
                                attrs: {
                                  width: 24,
                                  type: "circle",
                                  "stroke-width": 3,
                                  percentage: step.rate,
                                  "show-text": false
                                }
                              })
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "title",
                          fn: function() {
                            return [
                              _c("span", { staticClass: "txt-name" }, [
                                _vm._v(_vm._s(step.name))
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "txt-date" }, [
                                _vm._v(_vm._s(step.time))
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  })
                }),
                1
              )
            : _c("p", { staticClass: "no-progress" }, [_vm._v("暂无任务")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticClass: "btn-progress",
          attrs: { slot: "reference" },
          slot: "reference"
        },
        [
          _c("svg-icon", {
            attrs: { "icon-class": "progress", "class-name": "progress-style" },
            on: {
              mouseenter: function($event) {
                return _vm.getTaskProgress()
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-2f51d84a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2f51d84a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/Progress.vue
// module id = null
// module chunks = 